import { fetchToken } from "../../common/FetchCookie";
import { ADMIN, ADMIN_PRODUCT_REVIEW, BASE_URL, PRODUCT_REVIEW_LIST, PUBLIC } from "../../common/URLs";

export const fetchTestimonials = async () => {
  const url = `${BASE_URL}/${ADMIN}/${ADMIN_PRODUCT_REVIEW}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};
export const fetchTestimonialsPublic = async () => {
  const url = `${BASE_URL}/${PUBLIC}/${PRODUCT_REVIEW_LIST}?type=candidate`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addTestimonials = async (newTestimonials) => {
  const url = `${BASE_URL}/${ADMIN}/${ADMIN_PRODUCT_REVIEW}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newTestimonials),
    });
    const data = await response.json();
    // console.log("API Data", newTestimonials);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteTestimonials = async (uuid) => {
  try {
    const token = await fetchToken();

    const response = await fetch(
      `${BASE_URL}/${ADMIN}/${ADMIN_PRODUCT_REVIEW}/${uuid}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Error deleting : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting : " + error.message);
  }
};

export const updateTestimonials = async (uuid, testimonialsData) => {
  try {
    const token = await fetchToken();

    const response = await fetch(
      `${BASE_URL}/${ADMIN}/${ADMIN_PRODUCT_REVIEW}/${uuid}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(testimonialsData),
      }
    );

    if (!response.ok) {
      throw new Error("Error updating : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating : " + error.message);
  }
};
